export const STANDARD_PROHIBITED_ITEMS = {
  asbestos: ["asbestos"],
  paintOrPaintCans: ["paint", "paint can", "paint cans"],
  liquidChemicalsOrSolvents: ["chemical", "solvent", "solvents"],
  carBatteries: ["car battery", "car batteries"],
  rawMeatOrInPackaging: ["meat"],
  clinicalOrBiologicalWaste: ["clinical waste", "biological waste"],
  fireExtinguishers: ["fire extinguisher", "fire extinguishers"],
  gasBottles: ["gas bottle", "gas bottles"],
  oilsOrPetrol: ["oil", "oils", "petrol", "diesel", "fuel"],
} as const;

export const SKIP_PROHIBITED_ITEMS = {
  sofaMattressCushions: [
    "sofa",
    "sofas",
    "mattress",
    "mattresses",
    "cushion",
    "cushions",
    "bulk waste",
    "bulky waste",
    "upholstered furniture",
    "upholstered",
  ],
  asbestos: ["asbestos"],
  paintOrPaintCans: ["paint", "paint can", "paint cans"],
  liquidChemicalsOrSolvents: ["chemical", "solvent", "solvents"],
  carBatteries: ["car battery", "car batteries"],
  rawMeatOrInPackaging: ["meat"],
  clinicalOrBiologicalWaste: ["clinical waste", "biological waste"],
  fireExtinguishers: ["fire extinguisher", "fire extinguishers"],
  gasBottles: ["gas bottle", "gas bottles"],
  oilsOrPetrol: ["oil", "oils", "petrol", "diesel", "fuel"],
  plasterOrPlasterboard: ["plaster", "plasterboard"],
  fridgesOrFreezersOrAirConditioning: [
    "fridge",
    "fridges",
    "freezer",
    "freezers",
    "air conditioning",
    "air conditioner",
  ],
  weeeWasteElectricalsAppliances: [
    "WEEE",
    "WEEE waste",
    "electrical",
    "electricals",
    "appliance",
    "appliances",
  ],
} as const;
